import CryptoJS from 'crypto-js'
const KEY = CryptoJS.enc.Utf8.parse("SHARPAUTH1234567");
const IV = CryptoJS.enc.Utf8.parse('SHARPAUTH1234567');

export function Encrypt(word, keyStr, ivStr) {
  let key = KEY;
  let iv = IV;  
  if (keyStr) {
    key = CryptoJS.enc.Utf8.parse(keyStr);
    iv = CryptoJS.enc.Utf8.parse(ivStr);
  }
  let srcs = CryptoJS.enc.Utf8.parse(word);
  var encrypted = CryptoJS.AES.encrypt(srcs, key, {
    iv: iv, 
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.ZeroPadding
  });
  return CryptoJS.enc.Base64.stringify(encrypted.ciphertext);

}